import { NotAllow } from "assets/img/svg/notAllow";
import ExpandedHelpdeskIcon from "components/shared/ExpandedHelpdeskIcon";
import ThreeDotMenu from "components/shared/ThreeDotMenu";
import { useTranslation } from "react-i18next";

const CLOSE_PERIOD_DOC_LINK = "https://helpdesk.crealo.app/fr/article/cloturer-une-periode-xhf5s5/";

interface ManagementPeriodMenuProps {
    onClosePeriod: () => void;
}

export const ManagementPeriodMenu = ({ onClosePeriod }: ManagementPeriodMenuProps) => {
    const [t] = useTranslation();

    return (
        <ThreeDotMenu
            options={[
                {
                    id: "close-period",
                    name: (
                        <div className="flex items-center gap-2">
                            <span className="text-danger-text">{t("Management.ClosePeriodModal.ClosePeriod")}</span>
                            <span
                                className="[&_.helpdesk-expand-button]:max-h-6 [&_.helpdesk-expand-button]:text-[0.7rem]"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <ExpandedHelpdeskIcon
                                    link={CLOSE_PERIOD_DOC_LINK}
                                    text={t("Documentation.AccessDoc_title", {
                                        title: t("Documentation.ClosePeriod"),
                                    })}
                                />
                            </span>
                        </div>
                    ),
                    icon: (
                        <span className="flex text-danger-text">
                            <NotAllow width="14px" height="14px" />
                        </span>
                    ),
                    action: onClosePeriod,
                },
            ]}
        />
    );
};
